export function remainingFromTimestamps(startMs, endMs) {
  const value = endMs - startMs;
  const totalSeconds = Math.max(0, Math.floor(Math.abs(value) / 1000));
  return {
    value,
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}
